import { AutenticacaoContainer, Visao } from 'src/componentes'

export const DICA_CONSULTA_DOCUMENTOS_FILA =
  'Consulte os documentos enviados. A análise e aprovação são realizadas pela equipe iPGS.'

export const useSomenteConsultaDocumentosFilaTrabalho = (): boolean => {
  const { visao } = AutenticacaoContainer.useContainer()

  return visao === Visao.ParceiroCertificacao || visao === Visao.Parceiro
}
